import { IMG } from "@/lib/brand";
import { PageHero, Reveal, SectionEyebrow, HexIcon } from "@/components/Section";
import { HexWatermark } from "@/components/BrandMark";
import { useLang } from "@/lib/LanguageContext";

export default function Sustainability() {
  const { t } = useLang();
  const s = t.sustainability;

  return (
    <div data-testid="sustainability-page" className="bg-white">
      <PageHero
        testId="sustainability-hero"
        eyebrow={s.hero_eyebrow}
        title={s.hero_title}
        intro={s.hero_intro}
        image={IMG.texture1}
      />

      <section className="container-x py-24 sm:py-32">
        <div className="grid lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-7">
            <SectionEyebrow>{s.pillars_eyebrow}</SectionEyebrow>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl tracking-tight font-medium leading-[1.05]">
              {s.pillars_title_l1}
              <br />
              {s.pillars_title_l2}
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-muted-foreground leading-relaxed text-lg">{s.pillars_intro}</p>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-border border border-border">
          {s.pillars.map((p, i) => (
            <Reveal key={p.code} delay={i * 0.04}>
              <div data-testid={`sus-pillar-${i}`} className="bg-white p-8 sm:p-10 h-full">
                <div className="flex items-center justify-between">
                  <HexIcon className="text-accent">
                    <span className="text-accent font-display font-medium">{p.code}</span>
                  </HexIcon>
                  <span className="text-[11px] tabular-nums tracking-[0.18em] uppercase text-muted-foreground">
                    {s.pillar_label} {p.code}
                  </span>
                </div>
                <h3 className="mt-6 font-display text-xl font-medium tracking-tight">{p.title}</h3>
                <p className="mt-3 text-muted-foreground leading-relaxed">{p.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="relative bg-primary text-primary-foreground hex-pattern-light overflow-hidden">
        <HexWatermark
          opacity={0.07}
          size={720}
          strokeWidth={1.4}
          className="text-white -right-48 top-1/2 -translate-y-1/2"
        />
        <div className="relative container-x py-24 sm:py-32 grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6 img-zoom border border-white/10 aspect-[4/3]">
            <img src={IMG.lab2} alt="Material analysis" className="w-full h-full object-cover opacity-90" />
          </div>
          <div className="lg:col-span-6">
            <SectionEyebrow light>{s.method_eyebrow}</SectionEyebrow>
            <h3 className="mt-5 font-display text-white text-3xl sm:text-4xl tracking-tight font-medium leading-[1.05]">{s.method_title}</h3>
            <p className="mt-6 text-white/75 leading-relaxed text-lg">{s.method_intro}</p>
          </div>
        </div>
      </section>
    </div>
  );
}
